<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-card class="mx-auto mt-3" flat>
                        <v-card-text class="pa-0">
                            <v-layout row wrap>
                                <v-flex xs12 sm3 md2 pa-0>
                                    <v-layout inner-layout column fill-height>
                                        <v-flex hidden-xs-only border border-left-0 border-top-0 border-bottom-0 unselectable shrink style="height:5vh">
                                            &nbsp;
                                        </v-flex>
                                        <template v-for="(g,i) in group_options">
                                            <v-flex
                                                :class="current_active == i ? 'border-red-left-2 border border-left-2 border-right-0' : 'border border-left-0 border-top-0 border-bottom-0 grey--text' "
                                                :key="i"
                                                v-if="!g.permission || hasPerm(g.permission)"
                                                class="fs-14 clickable hover-black-text pl-1 pr-2 py-3 unselectable text-uppercase shrink"
                                                @mouseup.left="current_active != i ? $router.push({ name: 'configuration', params: { tab: i > 0 ? i : null } }) : ''"
                                            >
                                                <v-layout row inner-layout>
                                                    <v-flex style="max-width:30px;" ml-2>
                                                        <v-icon>{{g.icon}}</v-icon>
                                                    </v-flex>
                                                    <v-flex style="position: relative; bottom: -2px; left: 10px;">
                                                        {{ g.text }}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </template>
                                        <v-flex grow hidden-xs-only border border-left-0 border-top-0 border-bottom-0 unselectable pb-0>
                                            &nbsp;
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm9 md10>
                                    <div class="h-100">
                                        <v-layout row wrap class="pa-3">
                                            <v-flex xs12 text-center>
                                                <v-layout row wrap inner-layout pb-2>
                                                    <v-flex xs12 fs-22 text-uppercase>
                                                        {{ group_options[current_active].text }}
                                                    </v-flex>
                                                    <v-flex xs12 fs-14 pb-2 grey--text>
                                                        {{ group_options[current_active].description }}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm6 md4 v-for="(x,i) in current_group" :key="i" pb-3>
                                                <v-card class="mx-2 my-1 primary-hover clickable border rounded" flat min-width="130" height="80" @mouseup.left="$router.push({name: x.link})">
                                                    <v-layout row class="mt-3 unselectable">
                                                        <v-flex xs2>
                                                            <v-icon>{{ x.icon }}</v-icon>
                                                        </v-flex>
                                                        <v-flex xs10 style="font-size:16px;">
                                                            <v-layout row wrap inner-layout>
                                                                <v-flex xs12 fw-bold>
                                                                    {{ $t(`lang.${x.text}`) }}
                                                                </v-flex>
                                                                <v-flex xs12 fs-14>
                                                                    {{ x.description }}
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { store } from "Store/store";
import { configurationMenus } from "Modules/configuration/configuration_menu/menu.data.js";

export default {
    data() {
        return {
            group_options: configurationMenus,
            current_active: 0,
            mobile_list: [{ title: this.$t("lang.add_new"), action: "showMachine" }, { title: this.$t("lang.refresh"), action: "dbGetMachines" }],
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.current_active = to.params.tab ? to.params.tab : 0;
            vm.finishLoader();
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.finishLoader();
        this.current_active = to.params.tab ? to.params.tab : 0;
        next();
    },
    computed: {
        current_group() {
            return this.group_options[this.current_active].options;
        },
    },
    methods: {},
};
</script>
